export default function SkodaFooter() {
    const year = (new Date()).getFullYear();

    return (<>
        <div className="footer">
            <div className="footer-wrapper">
                <div className="footer-copyright">©Škoda Auto {year}</div>
                <div><a href="https://www.skoda-auto.pl/" target="_self">Przejdź do Škody</a></div>
            </div>
        </div>
    </>);
}
